import BackgroundImage from '../../assets/gpanel-arrow-background.svg';
import { useEffect } from 'react';

import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';

export default function HubspotTrialFormPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      // eslint-disable-next-line
      // @ts-ignore
      if (window.hbspt) {
        // eslint-disable-next-line
        // @ts-ignore
        window.hbspt.forms.create({
          portalId: '22148155',
          formId: 'fe0f1acb-abc4-404d-bd8f-5c1ec1e4d722',
          target: '#hubspotForm',
        });
      }
    });
  }, []);

  return (
    <Stack width={'100vw'} height={'100vh'} flexDirection="row">
      <img
        src={BackgroundImage}
        alt="gPanel Logo"
        width={'50%'}
        height={'100%'}
        style={{
          position: 'absolute',
          objectFit: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <SvgIcon
        sx={{
          width: 300,
          height: 'auto',
          position: 'absolute',
          padding: '2rem',
        }}
      >
        <svg
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 535.84 111.26"
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="m416.7,56.79c-1.3,0-2.3-.24-2.99-.7-.7-.47-1.21-.99-1.56-1.57h-.43v1.89h-2.73v-18.95h2.79v7.42h.43c.22-.36.51-.71.87-1.04.36-.33.84-.61,1.44-.83s1.33-.32,2.19-.32c1.12,0,2.15.27,3.09.81.94.54,1.69,1.33,2.25,2.36.56,1.03.84,2.26.84,3.68v.41c0,1.44-.28,2.68-.85,3.7-.57,1.02-1.32,1.8-2.25,2.34-.93.54-1.95.81-3.07.81Zm-.81-2.44c1.21,0,2.21-.39,2.99-1.16.79-.78,1.18-1.89,1.18-3.33v-.24c0-1.43-.39-2.53-1.16-3.3-.78-.78-1.78-1.16-3.01-1.16s-2.18.39-2.96,1.16c-.79.78-1.18,1.88-1.18,3.3v.24c0,1.44.39,2.55,1.18,3.33.79.78,1.77,1.16,2.96,1.16Z"
              />
              <path
                fill="#fff"
                d="m427.88,61.82v-2.44h7.45c.5,0,.76-.27.76-.81v-4.11h-.43c-.16.36-.41.71-.74,1.04-.33.33-.78.61-1.34.83-.56.22-1.26.33-2.11.33-1.01,0-1.91-.23-2.71-.68s-1.42-1.09-1.87-1.92c-.45-.83-.68-1.81-.68-2.95v-8.04h2.79v7.82c0,1.15.29,2.01.87,2.56s1.38.83,2.41.83c1.14,0,2.05-.38,2.75-1.14.7-.76,1.04-1.86,1.04-3.3v-6.77h2.79v16.08c0,.81-.24,1.46-.72,1.95s-1.13.73-1.96.73h-8.28Z"
              />
            </g>
            <g>
              <g>
                <g>
                  <path
                    fill="#fff"
                    d="m409.61,91.1v-19.89h2.9v2.04h.46c.36-.63.91-1.2,1.65-1.69.74-.5,1.79-.75,3.17-.75,1.19,0,2.27.29,3.26.86.99.57,1.78,1.4,2.38,2.48.6,1.08.9,2.39.9,3.92v.43c0,1.53-.3,2.84-.89,3.92-.59,1.08-1.39,1.91-2.38,2.48-1,.57-2.09.86-3.27.86-.92,0-1.69-.11-2.32-.34s-1.14-.52-1.52-.88c-.38-.35-.69-.72-.92-1.11h-.46v7.66h-2.96Zm7.32-7.92c1.3,0,2.36-.41,3.19-1.23.82-.82,1.23-2,1.23-3.53v-.26c0-1.51-.42-2.68-1.25-3.5-.83-.82-1.89-1.23-3.17-1.23s-2.31.41-3.14,1.23c-.83.82-1.25,1.99-1.25,3.5v.26c0,1.53.42,2.71,1.25,3.53.83.82,1.88,1.23,3.14,1.23Z"
                  />
                  <path
                    fill="#fff"
                    d="m427.29,85.36v-14.15h2.9v1.66h.46c.23-.59.6-1.03,1.1-1.31.51-.28,1.13-.42,1.88-.42h1.69v2.67h-1.81c-.96,0-1.74.26-2.35.79-.61.53-.92,1.33-.92,2.43v8.32h-2.96Z"
                  />
                  <path
                    fill="#fff"
                    d="m443.79,85.77c-1.42,0-2.67-.29-3.77-.88-1.1-.58-1.97-1.42-2.6-2.51-.63-1.09-.95-2.38-.95-3.87v-.43c0-1.49.32-2.78.95-3.86.63-1.08,1.5-1.92,2.6-2.51,1.1-.59,2.36-.89,3.77-.89s2.68.3,3.79.89c1.11.59,1.98,1.43,2.61,2.51s.95,2.37.95,3.86v.43c0,1.49-.32,2.78-.95,3.87s-1.5,1.93-2.61,2.51c-1.11.58-2.37.88-3.79.88Zm0-2.64c1.3,0,2.36-.42,3.17-1.25.81-.83,1.22-1.98,1.22-3.46v-.26c0-1.47-.4-2.63-1.21-3.46-.8-.83-1.87-1.25-3.19-1.25s-2.33.42-3.14,1.25c-.81.83-1.22,1.98-1.22,3.46v.26c0,1.47.41,2.63,1.22,3.46.81.83,1.86,1.25,3.14,1.25Z"
                  />
                  <path
                    fill="#fff"
                    d="m454.1,85.36v-14.15h2.9v1.66h.46c.27-.5.7-.94,1.29-1.32.59-.38,1.4-.57,2.41-.57s1.9.22,2.54.65c.64.43,1.12.98,1.45,1.65h.46c.33-.65.8-1.2,1.42-1.64.62-.44,1.51-.66,2.65-.66.92,0,1.73.19,2.44.56.71.37,1.27.93,1.69,1.66.42.74.63,1.65.63,2.74v9.41h-2.96v-9.18c0-.86-.23-1.53-.7-1.99-.47-.47-1.13-.7-1.99-.7-.92,0-1.66.3-2.21.89-.56.59-.83,1.44-.83,2.55v8.44h-2.96v-9.18c0-.86-.23-1.53-.7-1.99-.47-.47-1.13-.7-1.99-.7-.92,0-1.66.3-2.21.89-.56.59-.83,1.44-.83,2.55v8.44h-2.96Z"
                  />
                  <path
                    fill="#fff"
                    d="m484.46,85.77c-1.43,0-2.69-.3-3.76-.9-1.07-.6-1.91-1.45-2.51-2.55-.6-1.1-.9-2.38-.9-3.83v-.34c0-1.47.3-2.76.89-3.86.59-1.1,1.42-1.95,2.48-2.55s2.29-.9,3.69-.9,2.55.3,3.57.9c1.02.6,1.82,1.44,2.4,2.51.57,1.07.86,2.32.86,3.76v1.12h-10.88c.04,1.24.45,2.23,1.25,2.97.79.74,1.78,1.11,2.97,1.11,1.11,0,1.95-.25,2.51-.75.56-.5,1-1.07,1.31-1.72l2.44,1.26c-.27.54-.66,1.1-1.16,1.69-.51.59-1.17,1.09-1.99,1.49-.82.4-1.88.6-3.16.6Zm-4.13-8.93h7.84c-.08-1.07-.46-1.91-1.15-2.51-.69-.6-1.59-.9-2.7-.9s-2.01.3-2.71.9c-.7.6-1.12,1.44-1.28,2.51Z"
                  />
                  <path
                    fill="#fff"
                    d="m496.8,85.36l-4.76-14.15h3.13l3.76,11.97h.46l3.76-11.97h3.13l-4.76,14.15h-4.71Z"
                  />
                  <path
                    fill="#fff"
                    d="m514.57,85.77c-1.42,0-2.67-.29-3.77-.88-1.1-.58-1.97-1.42-2.6-2.51-.63-1.09-.95-2.38-.95-3.87v-.43c0-1.49.32-2.78.95-3.86.63-1.08,1.5-1.92,2.6-2.51,1.1-.59,2.36-.89,3.77-.89s2.68.3,3.79.89c1.11.59,1.98,1.43,2.61,2.51s.95,2.37.95,3.86v.43c0,1.49-.32,2.78-.95,3.87s-1.5,1.93-2.61,2.51c-1.11.58-2.37.88-3.79.88Zm0-2.64c1.3,0,2.36-.42,3.17-1.25.81-.83,1.22-1.98,1.22-3.46v-.26c0-1.47-.4-2.63-1.21-3.46s-1.87-1.25-3.19-1.25-2.33.42-3.14,1.25c-.81.83-1.22,1.98-1.22,3.46v.26c0,1.47.41,2.63,1.22,3.46.81.83,1.86,1.25,3.14,1.25Z"
                  />
                </g>
                <polygon
                  fill="#fff"
                  points="406.93 71.21 412.51 76.8 412.51 71.21 406.93 71.21"
                />
                <polygon
                  fill="#fff"
                  points="424.62 71.21 430.2 76.8 430.2 71.21 424.62 71.21"
                />
                <polygon
                  fill="#fff"
                  points="451.31 71.21 456.89 76.8 456.89 71.21 451.31 71.21"
                />
                <polygon
                  fill="#fff"
                  points="521.91 71.21 527.49 76.8 527.49 71.21 521.91 71.21"
                />
              </g>
              <path
                fill="#fff"
                d="m530.98,74v-2.33h-.94v-.47h2.39v.47h-.93v2.33h-.52Zm1.82,0v-2.79h.97l.59,2.33h.1l.58-2.33h.97v2.79h-.5v-2.33h-.11l-.59,2.33h-.79l-.58-2.33h-.11v2.33h-.52Z"
              />
            </g>
          </g>
          <path
            fill="#fff"
            d="m127.98,3.18C123.9,1.11,119.27.08,114.09.08h-41.54l7.82,7.82v77.09h13.1v-32.63h20.62c5.1,0,9.66-1.01,13.71-3.03,4.04-2.02,7.26-4.93,9.64-8.73,2.38-3.8,3.58-8.33,3.58-13.59v-1.58c0-5.26-1.15-9.76-3.46-13.53-2.3-3.76-5.5-6.67-9.58-8.73Zm-.06,23.72c0,4.21-1.38,7.52-4.12,9.95-2.75,2.43-6.43,3.64-11.04,3.64h-19.29V11.97h19.29c4.61,0,8.29,1.21,11.04,3.64,2.75,2.43,4.12,5.78,4.12,10.07v1.21Z"
          />
          <path
            fill="#fff"
            d="m198.67,70.92v-24.63c0-7.28-2.23-12.9-6.67-16.86-4.45-3.96-10.55-5.94-18.32-5.94-5.02,0-9.3.81-12.86,2.43-3.56,1.62-6.41,3.74-8.55,6.37-2.14,2.63-3.7,5.56-4.67,8.79l11.65,3.76c.73-3.23,2.22-5.86,4.49-7.88,2.26-2.02,5.54-3.03,9.83-3.03s7.6,1.05,9.7,3.15c2.1,2.1,3.15,4.89,3.15,8.37v3.88h-18.2c-4.37,0-8.27.69-11.71,2.06-3.44,1.38-6.15,3.42-8.13,6.13-1.98,2.71-2.97,6.13-2.97,10.25s.99,7.48,2.97,10.31c1.98,2.83,4.65,4.97,8.01,6.43,3.35,1.46,7.18,2.18,11.46,2.18s7.44-.59,9.95-1.76c2.51-1.17,4.41-2.57,5.7-4.19,1.29-1.62,2.26-3.03,2.91-4.25h1.82v.36c0,2.51.89,4.49,2.67,5.94,1.78,1.46,4.08,2.18,6.91,2.18h9.34v-10.43h-5.09c-2.26,0-3.4-1.21-3.4-3.64Zm-12.25-10.67c0,5.02-1.54,8.96-4.61,11.83-3.07,2.87-7.12,4.31-12.13,4.31-3.64,0-6.51-.81-8.61-2.43-2.1-1.62-3.15-3.8-3.15-6.55s1.01-4.83,3.03-6.25c2.02-1.41,4.69-2.12,8.01-2.12h17.47v1.21Z"
          />
          <path
            fill="#fff"
            d="m265.07,27.25c-3.52-2.02-7.54-3.03-12.07-3.03-5.74,0-10.07,1.05-12.98,3.15-2.91,2.1-4.93,4.37-6.07,6.79h-1.85v-9.25h-20.92l8.58,8.58v51.5h12.49v-30.21c0-6.47,1.56-11.4,4.67-14.8,3.11-3.4,7.26-5.09,12.43-5.09,4.53,0,8.09,1.23,10.67,3.7,2.59,2.47,3.88,6.29,3.88,11.46v34.94h12.49v-35.91c0-5.17-1.01-9.6-3.03-13.28-2.02-3.68-4.79-6.53-8.31-8.55Z"
          />
          <path
            fill="#fff"
            d="m330.68,27.32c-4.33-2.55-9.36-3.82-15.1-3.82s-11.1,1.27-15.59,3.82c-4.49,2.55-7.99,6.15-10.49,10.8-2.51,4.65-3.76,10.09-3.76,16.32v1.46c0,6.15,1.27,11.55,3.82,16.19,2.55,4.65,6.08,8.25,10.61,10.8,4.53,2.55,9.83,3.82,15.89,3.82,5.42,0,9.87-.85,13.34-2.55,3.48-1.7,6.29-3.8,8.43-6.31,2.14-2.51,3.78-4.89,4.91-7.16l-10.31-5.34c-1.29,2.75-3.13,5.18-5.52,7.28-2.39,2.1-5.93,3.15-10.61,3.15-5.02,0-9.2-1.56-12.56-4.67-3.36-3.11-5.12-7.3-5.28-12.55h45.97v-4.73c0-6.07-1.21-11.36-3.64-15.89-2.43-4.53-5.8-8.07-10.13-10.61Zm-32.09,21.65c.65-4.53,2.45-8.07,5.4-10.61,2.95-2.55,6.77-3.82,11.46-3.82s8.49,1.27,11.4,3.82c2.91,2.55,4.53,6.09,4.85,10.61h-33.12Z"
          />
          <polygon
            fill="#fff"
            points="356.43 .08 348 .08 356.43 8.51 356.43 85 368.92 85 368.92 21 368.92 .08 356.43 .08"
          />
          <path
            fill="#fff"
            d="m30.01,23.49c5.82,0,10.29,1.09,13.4,3.28,2.86,2.01,5.03,4.16,6.49,6.44.23.36.63.59,1.06.59.69,0,1.24-.56,1.24-1.24v-7.37h12.13v72.06c0,3.64-1.07,6.55-3.21,8.73-2.14,2.18-5.08,3.28-8.8,3.28H12.06v-10.92h36.39c2.34,0,3.52-1.21,3.52-3.64v-17.79c0-.69-.56-1.26-1.26-1.26-.43,0-.82.22-1.05.58-.86,1.27-1.99,2.58-3.39,3.91-1.62,1.54-3.74,2.79-6.37,3.76-2.63.97-5.92,1.46-9.89,1.46-5.02,0-9.64-1.19-13.89-3.58-4.25-2.38-7.62-5.82-10.13-10.31-2.51-4.49-3.76-9.84-3.76-16.07v-1.82c0-6.31,1.27-11.69,3.82-16.13,2.55-4.45,5.92-7.88,10.13-10.31,4.2-2.43,8.81-3.64,13.83-3.64m3.4,50.95c5.42,0,9.89-1.72,13.4-5.16,3.52-3.44,5.28-8.19,5.28-14.25v-1.09c0-6.23-1.74-11.02-5.22-14.37-3.48-3.36-7.97-5.03-13.47-5.03s-9.76,1.68-13.28,5.03c-3.52,3.36-5.28,8.15-5.28,14.37v1.09c0,6.07,1.76,10.82,5.28,14.25,3.52,3.44,7.95,5.16,13.28,5.16m-3.4-52.95c-5.35,0-10.34,1.31-14.83,3.91-4.49,2.59-8.15,6.31-10.86,11.05C1.61,41.19.23,46.95.23,53.58v1.82c0,6.54,1.35,12.28,4.01,17.05,2.68,4.79,6.34,8.52,10.9,11.08,4.53,2.54,9.53,3.83,14.87,3.83,4.18,0,7.74-.53,10.58-1.58,2.87-1.06,5.25-2.47,7.05-4.19.86-.82,1.64-1.64,2.32-2.46v15.57c0,1.41-.36,1.64-1.52,1.64H10.06v14.92h42.27c4.26,0,7.7-1.3,10.22-3.87,2.51-2.56,3.79-5.97,3.79-10.14V23.19h-16.13v7.05c-1.48-1.8-3.37-3.51-5.65-5.11-3.44-2.41-8.34-3.64-14.55-3.64h0Zm3.4,50.95c-4.84,0-8.73-1.5-11.88-4.59-3.15-3.07-4.68-7.27-4.68-12.82v-1.09c0-5.71,1.52-9.94,4.66-12.93,3.16-3.02,7.05-4.48,11.9-4.48s8.96,1.46,12.08,4.47c3.1,2.99,4.6,7.22,4.6,12.94v1.09c0,5.56-1.53,9.75-4.67,12.82-3.16,3.09-7.09,4.59-12.01,4.59h0Z"
          />
          <path
            fill="#fff"
            d="m414.5,15.02c-1.44,0-2.74-.32-3.88-.95s-2.04-1.52-2.7-2.65c-.66-1.13-.99-2.43-.99-3.89s.33-2.76.99-3.89c.66-1.13,1.56-2.01,2.7-2.65s2.44-.96,3.88-.96,2.74.32,3.88.96,2.05,1.52,2.71,2.65c.66,1.13.99,2.43.99,3.89s-.33,2.76-.99,3.89c-.66,1.13-1.56,2.02-2.71,2.65s-2.43.95-3.88.95Zm0-1.48c1.83,0,3.29-.55,4.38-1.64,1.09-1.09,1.64-2.55,1.64-4.38s-.55-3.29-1.64-4.38c-1.09-1.09-2.55-1.64-4.38-1.64s-3.29.55-4.4,1.64c-1.11,1.09-1.66,2.56-1.66,4.38s.55,3.29,1.66,4.38c1.11,1.09,2.57,1.64,4.4,1.64Zm-2.59-2.09V3.45h3.06c.89,0,1.56.21,2.02.65.46.43.69.94.69,1.51,0,.48-.11.9-.34,1.24s-.6.62-1.1.81v.29c.41.02.7.16.88.41.18.25.27.56.27.92v2.17h-1.48v-2.2c0-.5-.25-.76-.76-.76h-1.8v2.96h-1.44Zm1.44-4.26h1.66c.41,0,.71-.13.9-.38.19-.25.29-.54.29-.85,0-.34-.1-.62-.29-.85-.19-.23-.49-.34-.9-.34h-1.66v2.42Z"
          />
          <polygon
            fill="#fff"
            points="377.36 0 398.23 20.87 398.23 0 377.36 0"
          />
        </svg>
      </SvgIcon>
      <Stack
        width="50%"
        justifyContent="center"
        alignItems="center"
        sx={{ zIndex: 3 }}
      >
        <Card
          sx={{
            width: 600,
            p: 2,
            bgcolor: 'rgba(255, 255, 255, 0.9)',
          }}
        >
          <CardHeader
            title="Get Started With gPanel®"
            sx={{
              pb: 0,
              color: '#233166',
            }}
          />
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              pt: 0,
            }}
          >
            <Typography sx={{ color: '#233166', fontWeight: 'light', mt: 1 }}>
              Thank you for your interest in gPanel®, Promevo’s own Google
              Workspace management platform!
            </Typography>
            <Typography sx={{ color: '#233166', fontWeight: 'light', mt: 1 }}>
              Before we set you up with an account, we’d like to schedule a
              brief meeting with our sales team, so we can give you a
              personalized tour of gPanel and help you set up your account.
            </Typography>
            <Typography sx={{ color: '#233166', fontWeight: 'light', mt: 1 }}>
              During this session, you’ll receive:
            </Typography>
            <Typography sx={{ color: '#233166', fontWeight: 'light' }}>
              <ul style={{ padding: '0 0 0 24px' }}>
                <li>
                  A detailed walkthrough of gPanel's key features and benefits.
                </li>
                <li>
                  A live demonstration of how gPanel can address your unique use
                  case.
                </li>
                <li>
                  A step-by-step guide to setting up your gPanel instance.
                </li>
                <li>
                  An opportunity to ask questions and get expert advice from our
                  team.
                </li>
              </ul>
            </Typography>
            <Typography sx={{ color: '#233166', fontWeight: 'light' }}>
              Simply fill out the form to schedule a quick setup session with
              our team.
            </Typography>
            <Typography sx={{ color: '#233166', fontWeight: 'light', mt: 1 }}>
              We look forward to showing you how gPanel can benefit your
              organization!
            </Typography>
          </CardContent>
        </Card>
      </Stack>
      <Stack
        sx={{ bgcolor: '#F1F1F1', width: '50vw' }}
        justifyContent="center"
        alignItems="center"
      >
        <Card sx={{ width: 650, minHeight: 660, zIndex: 3 }}>
          <CardContent>
            <div id="hubspotForm"></div>
          </CardContent>
        </Card>
      </Stack>
    </Stack>
  );
}
